module.exports = __webpack_public_path__ + "static/media/nursecare.c055babe.jpg";